import React from 'react'
import styled from 'styled-components'
import { motion, AnimatePresence } from 'framer-motion'
import { useScrollPosition } from '../../hooks/useScrollPosition'

const IndicatorContainer = styled(motion.div)`
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  cursor: pointer;
`

const Arrow = styled.div`
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 20px solid ${props => props.theme.colors.text.secondary};
  transition: all 0.3s ease;

  &:hover {
    border-top-color: ${props => props.theme.colors.accent.blue};
  }
`

const ScrollIndicator = () => {
    const scrollPosition = useScrollPosition()

    const handleClick = () => {
        window.scrollTo({
            top: window.innerHeight,
            behavior: 'smooth'
        })
    }

    return (
        <AnimatePresence>
            {scrollPosition < 100 && (
                <IndicatorContainer
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    whileHover={{ y: -5 }}
                    onClick={handleClick}
                >
                    <Arrow />
                </IndicatorContainer>
            )}
        </AnimatePresence>
    )
}

export default ScrollIndicator